<template>
	<div class="install_body">
		<div class="install">
			<div class="install_content">
				<div class="install_title">下载插件</div>
				<div class="install_msg">
					请先确定您的设备属于哪个架构平台，然后选择下载对应的插件进行安装。
				</div>
				<div class="install_list">
					<div class="install_item" v-if="false">
						<span>创米小白</span>
						<a
							href="https://cdn.ionewu.com/publish/wwxz/cm/arm64.tar.gz"
							class="install_btn"
							>arm_64</a
						>
					</div>
					<div class="install_item" v-if="false">
						<span>Q&nbsp;N&nbsp;A&nbsp;P</span>
						<a
							href="https://cdn.ionewu.com/publish/wwxz/qnap/x86_64.pqkg"
							class="install_btn"
							>X86_64</a
						>
					</div>
					<div class="install_item" v-if="false">
						<span>铁威马</span>
						<a
							href="https://cdn.ionewu.com/publish/wwxz/tnas/x86_64.tpk"
							class="install_btn"
							>X86_64</a
						>
						<a
							href="https://cdn.ionewu.com/publish/wwxz/tnas/aarch64.tpk"
							class="install_btn"
							>aarch_64</a
						>
					</div>
					<div class="install_item" v-if="false">
						<span>华芸</span>
						<a
							href="https://cdn.ionewu.com/publish/wwxz/asus/arm64.apk"
							class="install_btn"
							>arm_64</a
						>
						<a
							href="https://cdn.ionewu.com/publish/wwxz/asus/x86-64.apk"
							class="install_btn"
							>X86_64</a
						>
						<a
							href="https://cdn.ionewu.com/publish/wwxz/asus/arm.apk"
							class="install_btn"
							>arm</a
						>
						<a
							href="https://cdn.ionewu.com/publish/wwxz/asus/i386.apk"
							class="install_btn"
							>i386</a
						>
					</div>
					<div class="install_item">
						<span>群晖</span>
						<a
							href="https://cdn.ionewu.com/upgrade/d/DSM6_owapp-x86_64-2.3.21-6119.spk"
							title="玩物下载群晖DSM6_x86"
							class="install_btn"
							>DSM6_x86</a
						>
						<a
							href="https://cdn.ionewu.com/upgrade/d/DSM6_owapp-armv8-2.3.21-6119.spk"
							title="玩物下载群晖DSM6_arm"
							class="install_btn"
							>DSM6_arm</a
						>
						<a
							href="https://cdn.ionewu.com/upgrade/d/DSM7_owapp-x86_64-2.3.21-7130.spk"
							title="玩物下载群晖DSM7_x86"
							class="install_btn"
							>DSM7_x86</a
						>
						<a
							href="https://cdn.ionewu.com/upgrade/d/DSM7_owapp-armv8-2.3.21-7130.spk"
							title="玩物下载群晖DSM7_arm"
							class="install_btn"
							>DSM7_arm</a
						>
					</div>
				</div>
				<div class="install_other">
					联想、海康：请在设备应用中心下载安装。
				</div>
				<div class="install_close" @click="onClose">关闭</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		onClose: function () {
			this.$emit("Close");
		},
	},
};
</script>

<style lang="less" scoped>
.install_body {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.3);
	z-index: 8;
}
.install {
	// width: 418px;
	// height: 454px;
	width: 590px;
	height: 320px;
	background-image: url(../assets/install_bg.png);
	background-size: 100% 100%;
	background-repeat: no-repeat;
	font-family: Microsoft YaHei;
	position: absolute;
	top: 50%;
	left: 50%;
	// margin-top: -230px;
	// margin-left: -200px;
	margin-top: -160px;
	margin-left: -295px;

	.install_content {
		width: 80%;
		margin-left: 44px;
		margin-top: 43px;
		.install_title {
			color: #343434;
			font-size: 18px;
			padding-left: 8px;
			background-image: url(../assets/title_icon.png);
			background-size: 5px 16px;
			background-repeat: no-repeat;
			background-position: left center;
		}
		.install_msg {
			color: #666666;
			font-size: 15px;
			text-indent: 2em;
			line-height: 22px;
			margin-top: 30px;
		}
		.install_list {
			font-size: 14px;
			color: #666666;
			margin-top: 19px;

			.install_item {
				border-top: 1px solid rgba(176, 176, 176, 0.3);
				padding: 10px 9px;

				span {
					margin-right: 20px;
					width: 57px;
					display: inline-block;
					text-align: justify;
					text-align-last: justify;
				}

				.install_btn {
					height: 23px;
					padding: 0 7px;
					line-height: 22px;
					margin-right: 5px;
					display: inline-block;
					background: #daedf7;
					border: 1px solid #b8dcee;
					border-radius: 11px;
					color: #07a8ff;
					text-align: center;
				}
			}
			.install_item:last-child {
				border-bottom: 1px solid rgba(176, 176, 176, 0.3);
			}
		}
		.install_other {
			color: #666666;
			font-size: 14px;
			text-align: right;
			margin-top: 19px;
		}
		.install_close {
			width: 80px;
			height: 30px;
			color: #fefefe;
			font-size: 14px;
			background: #06a8ff;
			text-align: center;
			line-height: 30px;
			border-radius: 4px;
			margin: 0 auto;
			margin-top: 20px;
			cursor: pointer;
		}
	}
}
</style>